import { useContext } from "react";
import { UserContext } from "./UserGateway";
import { CompanyContext } from "./CompanyGateway";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'stripe-pricing-table': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

export default function SignUpFlow() {
  const user = useContext(UserContext);
  const company = useContext(CompanyContext);

  return <>
    <stripe-pricing-table
      pricing-table-id={company.stripePricingTableId}
      publishable-key={company.stripePublishableKey}
      client-reference-id={user.uid}
      customer-email={user.email} />
  </>

}